<template>
  <div class="demo-layout mdl-layout mdl-js-layout mdl-layout--fixed-drawer mdl-layout--fixed-header">
    <header class="demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">
        <span class="mdl-layout-title"><span v-if="$store.state.companyData">{{ $store.state.companyData.company.name }}</span></span>
        <div class="mdl-layout-spacer"></div>
        <!-- <nav class="mdl-navigation">
          <a class="mdl-navigation__link mdl-color--grey-100 mdl-color-text--grey-800"
            @click="logout">
            logout
          </a>
        </nav> -->
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable">
            <label class="mdl-button mdl-js-button mdl-button--icon" for="search">
              <i class="material-icons">search</i>
            </label>
            <div class="mdl-textfield__expandable-holder">
              <input class="mdl-textfield__input" type="text" id="search">
              <label class="mdl-textfield__label" for="search">Enter your query...</label>
            </div>
          </div>
          <button class="mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon" id="hdrbtn">
            <i class="material-icons">more_vert</i>
          </button>
          <ul class="mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--bottom-right" for="hdrbtn">
            <li class="mdl-menu__item">About</li>
            <li class="mdl-menu__item">Contact</li>
            <li class="mdl-menu__item">Legal information</li>
            <li class="mdl-menu__item" @click="logout">Log Out</li>
          </ul>
      </div>
    </header>
    <div class="demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50">
      <header class="demo-drawer-header">
        <img src="@/assets/user.jpg" class="demo-avatar">
        <div class="demo-avatar-dropdown">
          <span id="current-email">hello@example.com</span>
          <div class="mdl-layout-spacer"></div>
          <button id="accbtn" class="mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon">
            <i class="material-icons" role="presentation">arrow_drop_down</i>
            <span class="visuallyhidden">Accounts</span>
          </button>
          <ul class="mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect" for="accbtn">
            <!-- <li class="mdl-menu__item">hello@example.com</li>
            <li class="mdl-menu__item">info@example.com</li> -->
            <li class="mdl-menu__item"><i class="material-icons">add</i>Add another account...</li>
          </ul>
        </div>
      </header>

      <nav class="demo-navigation mdl-navigation mdl-color--blue-grey-800">
        <router-link class="mdl-navigation__link" to="/home" @click.native="hideMenu">
          <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">home</i>
          Home
        </router-link>
        <router-link class="mdl-navigation__link" to="/bills" @click.native="hideMenu">
          <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">inbox</i>
          All bills
        </router-link>
        <router-link class="mdl-navigation__link" to="/add" @click.native="hideMenu">
          <i class="mdl-color-text--blue-grey-400 material-icons" role="presentation">shopping_cart</i>
          Add Bill
        </router-link>

      </nav>
    </div>
    <main class="mdl-layout__content mdl-color--grey-100">
      <router-view></router-view>

    </main>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
// import 'material-design-lite'
export default {
  name: 'app',
  data () {
    return {
    }
  },
  computed: {
    // ...mapState({
    //
    // }),
    // ...mapGetters(['doubleup']),
    // halfCount () {
    //   return this.count / 2;
    // },
  },
  methods: {
    hideMenu: function () {
      document.getElementsByClassName('mdl-layout__drawer')[0].classList.remove('is-visible')
      document.getElementsByClassName('mdl-layout__obfuscator')[0].classList.remove('is-visible')
    },
    logout () {
      firebase.auth().signOut()
        .then(() => {
          this.$router.push('login')
        })
    }
  },
  created: function () {
    // console.log('created ')
    // console.log(this.$store.state.userData.user)
    this.$nextTick(() => {
      window.componentHandler.upgradeDom()
      window.componentHandler.upgradeAllRegistered()
    })
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');
  @import url('https://code.getmdl.io/1.2.1/material.blue-red.min.css');
  .mdl-button{
    color: mdl-color-text--blue-grey-50;
  }
  .center-items {
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue